// gkc_hash_code : 01E7J1BV41XHVJMHH8Y4PHXG7H
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ol,
  ul {
    margin: 0;
    padding: 0;
  }

  body {
    min-width: 1280px;
    line-height: 1;
    font-family: 'Hiragino Sans', 'Noto Sans Japanese', 'Yu Gothic', 'Meiryo',
      'Hiragino Kaku Gothic Pro', '游ゴシック', 'メイリオ', 'MS ゴシック', sans-serif;

    @media only screen and (max-width: 428px) {
      min-width: unset;
    }
  }

  ol,
  ul {
    list-style: none;
  }

  a {
    &,
    &:focus,
    &:hover {
      outline: none;
      text-decoration: none !important;
    }
  }

  button {
    &,
    &.button {
      &:focus {
        outline: 0 none;
      }
    }
  }

  button::-moz-focus-inner {
    border: 0;
  }

  input[type="checkbox"]:focus {
    outline: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6 {
    font-weight: 400;
  }

  :focus {
    outline: none;
  }

  * {
    margin: 0;
    padding: 0;

    &,
    &:before,
    &:after {
      box-sizing: border-box;
    }
  }

  body {
    background-color: #fff;
    color: #000;
  }

  input {
    &:focus {
      outline: none;
    }

    &[type=number] {
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }
    }
  }

  table {
    width: 100%;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;

    @media only screen and (max-width: 428px) {
      width: 5px;
    }
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #be8d06;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #666666;
  }
`;

export default GlobalStyle;
